import { Injectable, inject } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class FirstAppLaunchService {
  private storage = inject(Storage);

  private readonly HAS_LAUNCHED_KEY = 'hasLaunchedAppBefore';

  public async isFirstLaunch(): Promise<boolean> {
    const hasLaunched = await this.storage.get(this.HAS_LAUNCHED_KEY);
    if (hasLaunched === null) {
      return true;
    }
    return false;
  }

  public async setHasLaunched(): Promise<void> {
    await this.storage.set(this.HAS_LAUNCHED_KEY, true);
  }
}
